import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { useCallback } from 'react';
import { createTransformer } from '../core';
var createBreadcrumbSentryContext = function createBreadcrumbSentryContext(breadcrumbs) {
  var breadcrumbContext = {};
  var _iterator = _createForOfIteratorHelper(breadcrumbs),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var breadcrumb = _step.value;
      // TODO: Should avoid conflicts
      breadcrumbContext[breadcrumb.name.toString()] = breadcrumb;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return breadcrumbContext;
};
/**
 * Creates a copy of original the sentry exception payload but
 * enhanced with extra information like source and telemetry breadcrumbs
 */
export var withSentryExceptionTelemetryInformation = function withSentryExceptionTelemetryInformation(_ref) {
  var breadcrumbs = _ref.breadcrumbs,
    _ref$payload = _ref.payload,
    exception = _ref$payload.exception,
    hint = _ref$payload.hint,
    scopeContext = _ref$payload.scopeContext;
  var errorThatRevealsDispatchStackTrace = new Error();
  var sentryPayload = {
    exception: exception,
    hint: _objectSpread({
      syntheticException: errorThatRevealsDispatchStackTrace
    }, hint),
    scopeContext: _objectSpread(_objectSpread({}, scopeContext), {}, {
      contexts: _objectSpread(_objectSpread({}, scopeContext === null || scopeContext === void 0 ? void 0 : scopeContext.contexts), {}, {
        telemetryBreadcrumbs: createBreadcrumbSentryContext(breadcrumbs)
      })
    })
  };
  return sentryPayload;
};
export var arbitraryValueToSentryException = function arbitraryValueToSentryException(_ref2) {
  var _ref2$breadcrumbedPay = _ref2.breadcrumbedPayload,
    breadcrumbs = _ref2$breadcrumbedPay.breadcrumbs,
    payload = _ref2$breadcrumbedPay.payload;
  return withSentryExceptionTelemetryInformation({
    breadcrumbs: breadcrumbs,
    payload: {
      exception: payload
    }
  });
};
export var createSentryExceptionEventTransformer = function createSentryExceptionEventTransformer(_ref3) {
  var from = _ref3.from,
    to = _ref3.to,
    useTransformer = _ref3.useTransformer;
  // Gotta be outside the scope otherwise hooks will keep recomputing
  var useSentryTransformer = function useSentryTransformer(transformProps) {
    var transform = useTransformer(transformProps);
    return useCallback(function (_ref4) {
      var breadcrumbs = _ref4.breadcrumbs,
        originalPayload = _ref4.payload;
      var sentryPayload = transform(originalPayload);
      return withSentryExceptionTelemetryInformation({
        payload: sentryPayload,
        breadcrumbs: breadcrumbs
      });
    }, [transform]);
  };
  var ArbitraryEventToConnectedEvent = createTransformer({
    from: from,
    to: to,
    useTransformer: useSentryTransformer
  });
  return ArbitraryEventToConnectedEvent;
};

/**
 * This will create a bridge that listens to arbitrary objects
 * and uploads them as exceptions in Sentry
 */
export var createSentryExceptionEventTransformerFromArbitraryObject = function createSentryExceptionEventTransformerFromArbitraryObject(_ref5) {
  var from = _ref5.from,
    to = _ref5.to;
  return createTransformer({
    from: from,
    to: to,
    useTransformer: function useTransformer() {
      return useCallback(function (breadcrumbedPayload) {
        return arbitraryValueToSentryException({
          breadcrumbedPayload: breadcrumbedPayload
        });
      }, []);
    }
  });
};